var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"right-bar"},[(_vm.userId > 0)?[_c('img',{attrs:{"src":_vm.avatar,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userName))]),_vm._v(" "),_c('a',{on:{"click":_vm.logout}},[_vm._v("退出")])]:[_c('a',{on:{"click":_vm.login}},[_vm._v("登录")])]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2759f23e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = null
// module chunks = 